import GeneralFilter from '../../../../Model/GeneralFilter'

export default class SystemWalletFilter extends GeneralFilter {
  constructor () {
    super()
    this.setInitialValue()
  }

  setInitialValue () {
    this.setFilterInitialValue()
  }
}
